import { render, staticRenderFns } from "./GroupReview.vue?vue&type=template&id=54d014e0&scoped=true"
import script from "./GroupReview.vue?vue&type=script&lang=js"
export * from "./GroupReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d014e0",
  null
  
)

export default component.exports